// eslint-disable-next-line no-restricted-syntax
export enum Breakpoint {
  MOBILE = 1200,
  HALF_MOBILE = 600,
  DESKTOP = -1,
}

export const getBreakpoint = (breakpoint: number) =>
  `@media only screen and (max-width: ${breakpoint}px)`
